import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC5QLAaxuKq3j1YR0r16d0xpbihje8_ADM",
    authDomain: "chat-app-c5249.firebaseapp.com",
    projectId: "chat-app-c5249",
    storageBucket: "chat-app-c5249.appspot.com",
    messagingSenderId: "1011545630842",
    appId: "1:1011545630842:web:0d9aba7a5eef4f3038f3c3",
    measurementId: "G-6XC2ET4K02"
  };
  
const app = firebase.initializeApp(firebaseConfig);
const database = app.firestore();

export default database;